<template>
  <div>
    <div class="col-12 alert alert-light py-0 mb-0 py-0 d-none d-sm-flex" v-if="false">
      <div class="col-3 col-sm-4">
        <a href="" class="btn btn-light mr-2">
          <i class="bi bi-envelope fs-5 text-danger pl-2"></i>
        </a>
      </div>
      <div class="col-9 col-sm-8 text-end p-0">
        <social btn="light" />
      </div>
    </div>

    <div class="col-12 alert py-0 mb-0 py-0 d-sm-flex justify-content-center border-bottom border-3">
      <router-link @click="clickmenu" to="/" id="logo_url">
        <img :src="logo" :alt="alt" id="logo" />
      </router-link>
    </div>
    <nav class="navbar navbar-expand-lg border-bottom" data-bs-theme="">
      <div class="container">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler"
          aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarToggler">
          <Menu @clickmenu="clickmenu" />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Social from './Social.vue';
import Menu from './Menu.vue';
export default {
  components: { Social, Menu },
  name: "Navbar",
  props: ["logo", "alt"],
  data() {
    return {
      link: "",
    };
  },
  methods: {
    clickmenu: function () {
      const element = document.getElementById("navbarToggler");
      element.classList.remove("show");
    },
  },
};
</script>

<style scoped>
#logo {
  max-height: 150px;
}
</style>